// Mobile Product Card Navigation
document.addEventListener('DOMContentLoaded', function() {
  // Function to directly connect navigation buttons to Flickity
  const connectNavButtons = () => {
    // Find all product cards
    const productCards = document.querySelectorAll('.product-card__media');
    
    productCards.forEach(card => {
      // Find the carousel and navigation buttons
      const carousel = card.querySelector('secondary-media');
      const prevButton = card.querySelector('button[is="previous-button"]');
      const nextButton = card.querySelector('button[is="next-button"]');
      
      if (!carousel || !prevButton || !nextButton) return;
      
      // Find the original image to hide it when navigating
      const originalImage = card.querySelector('a > img');
      
      // Function to hide the original image when carousel is active
      const hideOriginalImage = () => {
        if (originalImage && carousel.carousel && carousel.carousel.selectedIndex > 0) {
          originalImage.style.opacity = '0';
          originalImage.style.visibility = 'hidden';
        } else if (originalImage) {
          originalImage.style.opacity = '';
          originalImage.style.visibility = '';
        }
      };
      
      // Direct click handlers for navigation buttons
      prevButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (carousel.carousel) {
          carousel.carousel.previous();
          hideOriginalImage();
        }
      };
      
      nextButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (carousel.carousel) {
          carousel.carousel.next();
          hideOriginalImage();
          
          // Hide the original image when navigating
          if (originalImage) {
            originalImage.style.opacity = '0';
            originalImage.style.visibility = 'hidden';
          }
        }
      };
      
      // Only hide pagination dots on mobile
      if (carousel.carousel) {
        const pageDots = carousel.querySelector('.flickity-page-dots');
        if (pageDots) {
          // Check if we're on mobile
          if (window.matchMedia('(max-width: 767px)').matches) {
            pageDots.style.display = 'none';
          } else {
            pageDots.style.display = '';
            pageDots.style.opacity = '1';
            pageDots.style.visibility = 'visible';
          }
        }
        
        // Make sure the carousel is properly initialized
        carousel.carousel.resize();
        
        // Listen for carousel change event
        carousel.addEventListener('change', hideOriginalImage);
      }
      
      // Allow clicking on carousel to navigate to product page
      // But prevent it during drag events
      if (carousel && carousel.carousel) {
        let isDragging = false;
        
        carousel.carousel.on('dragStart', function() {
          isDragging = true;
        });
        
        carousel.carousel.on('dragEnd', function() {
          setTimeout(function() {
            isDragging = false;
          }, 100); // Small delay to ensure click doesn't trigger navigation after drag
        });
        
        carousel.addEventListener('click', function(e) {
          // Only prevent navigation if we're dragging
          if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
          }
          // Otherwise allow the click to navigate to the product page
        });
      }
    });
  };
  
  // Fix for filter and sort buttons on mobile
  const fixFilterSortButtons = () => {
    // Only run on mobile
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    
    // Find the facet-sticky element
    const facetSticky = document.querySelector('facet-sticky');
    if (!facetSticky) return;
    
    // Ensure it's visible
    facetSticky.style.display = 'block';
    facetSticky.style.opacity = '1';
    facetSticky.style.visibility = 'visible';
    facetSticky.style.pointerEvents = 'auto';
    
    // Find the button inside
    const button = facetSticky.querySelector('button');
    if (!button) return;
    
    // Ensure the button is visible
    button.style.display = 'flex';
    button.style.opacity = '1';
    button.style.visibility = 'visible';
    button.style.pointerEvents = 'auto';
  };
  
  // Run on page load with a delay to ensure everything is initialized
  setTimeout(() => {
    connectNavButtons();
    fixFilterSortButtons();
  }, 1000);
  
  // Also run on window resize
  window.addEventListener('resize', () => {
    connectNavButtons();
    fixFilterSortButtons();
  });
  
  // Run again after any potential dynamic content loads
  document.addEventListener('shopify:section:load', function() {
    setTimeout(() => {
      connectNavButtons();
      fixFilterSortButtons();
    }, 500);
  });
  
  // Run periodically to ensure everything is connected
  setInterval(() => {
    fixFilterSortButtons();
  }, 2000);
}); 